import React, { useState, useEffect } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import { uploadCsv } from '../../store/actions/vendor/Vendor';
// @material-ui/core components
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import CustomInput from '../../components/CustomInput/CustomInput.js';
// core components
import { connect } from 'react-redux';
import CsvDownload from 'react-json-to-csv'
import {
  getAllProducts,
  getCompleteProducts,
  deleteProduct,
  getSuperCategory as getAllCategoryList,
  getAllSubCategory,
  getAllCategory as getCategoryList,
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import BackDrop from '../../components/User/Preloader/BackDrop';
import GlobalSearch from '../../components/Common/GlobalSearch';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

var update = false;
function ProductTable(props) {
  const classes = useStyles();
  const query = new URLSearchParams(props.location.search)
  const page_no = query.get('page_no')
  const category = query.get('category')
  const sub_category = query.get('sub_category')
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [usePage, setUsePage] = useState(false)
  const [searchText, setSearchText] = useState('');
  const [superCategoryId, setSuperCategoryId] = useState('');
  const [categoryId, setCategoryId] = useState(category ? category : '');
  const [subCategoryId, setSubCategoryId] = useState(sub_category ? sub_category : '');
  const [uploadMessage, setUploadMessage] = useState(null)

  useEffect(() => {
    if (props.superCategories && props.superCategories.length > 0)
      props.getCategoryList(props.superCategories[0]?.id);
  }, [props.superCategories]);

  useEffect(() => {
    props.getAllProducts(searchText, superCategoryId, categoryId, subCategoryId, page);
    props.getCompleteProducts(searchText, superCategoryId, categoryId, subCategoryId)
  }, []);

  useEffect(() => {
    props.getAllCategoryList();
  }, []);

  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  const data = [];
  {
    var c = 1;
    props.products &&
      props.products.map((category) => {
        data.push({
          sno: c,
          name: category
        });
        c += 1;
      });
  }

  const handleDelete = (productId) => {
    props.deleteProduct(productId);
    setTimeout(() => {
      props.getAllProducts(searchText, superCategoryId, categoryId, subCategoryId, page);
      props.getCompleteProducts(searchText, superCategoryId, categoryId, subCategoryId)
    }, 1500);
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getAllProducts(searchText, superCategoryId, categoryId, subCategoryId, value);
  };
  const onChangeSuperCategory = (event) => {
    setSuperCategoryId(event.target.value)
    props.getAllCategoryList(event.target.value);
    setCategoryId('')
    setSubCategoryId('')
    setPage(1)
    props.getAllProducts(searchText, event.target.value, categoryId, subCategoryId, 1);
    props.getCompleteProducts(searchText, event.target.value, categoryId, subCategoryId)
  };
  const onChangeCategory = (event) => {
    setCategoryId(event.target.value)
    props.getAllSubCategory(event.target.value);
    setSubCategoryId('')
    setPage(1)
    props.getAllProducts(searchText, superCategoryId, event.target.value, subCategoryId, 1);
    props.getCompleteProducts(searchText, superCategoryId, event.target.value, subCategoryId)
  };
  const onChangeSubCategory = (event) => {
    setSubCategoryId(event.target.value)
    setPage(1)
    props.getAllProducts(searchText, superCategoryId, categoryId, event.target.value, 1);
    props.getCompleteProducts(searchText, superCategoryId, categoryId, event.target.value)
  };
  const handleSearchSubmit = () => {
    props.getAllProducts(searchText, superCategoryId, categoryId, subCategoryId, page);
    props.getCompleteProducts(searchText, superCategoryId, categoryId, subCategoryId)
  }
  const onUpload = (event) => {
    setUploadMessage('Uploading the file, please wait...');

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    props
      .upload(data)
      .then((response) => {
        if (response.status === 200) {
          props.getAllProducts(searchText, superCategoryId, categoryId, subCategoryId);
          props.getCompleteProducts(searchText, superCategoryId, categoryId, subCategoryId)
          setUploadMessage('Product added successfully.');
        } else {
          setUploadMessage('Please, try Again');
        }
      })
      .catch((error) => {
        setUploadMessage('An error occurred while executing the query. Please try Again');
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };
  return (
    <>
      <BackDrop open={props.api_loading} />
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>All Products</h4>
        <GridContainer justify="center" direction="row"
          alignItems="center">
          <GridItem justify="center"
            alignItems="center" xs={12} sm={12} md={6} style={{ textAlign: 'center' }}>
            <GlobalSearch width={'500px'} onChange={(event) => {
              setSearchText(event.target.value)
            }}
              title={"Search in Products (Press Enter to Search)"}
              handleSubmit={handleSearchSubmit}
            />
          </GridItem>
        </GridContainer>
        <GridContainer justify="center" direction="row"
          alignItems="center">
          <GridItem justify="center"
            alignItems="center" xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Product Image"
              id="image"
              type="file"
              name="image"
              accept="csv"
              onChange={onUpload}
              formControlProps={{
                fullWidth: true
              }}
            />
            <br />
            <p style={{ color: '#000' }}>
              {uploadMessage}
            </p>
          </GridItem>
          <GridItem justify="center"
            alignItems="center" xs={12} sm={12} md={6}>
            {props.complete_products && <CsvDownload style={{ backgroundColor: 'grey' }} filename="Products.csv" data={props.complete_products} />}
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <select
              className="form-control"
              value={superCategoryId}
              onChange={onChangeSuperCategory}
            >
              <option selected="selected">
                Select Super Category
              </option>
              {props.superCategories.length > 0 && (
                props.superCategories.map((type) => (
                  <option value={type.id} key={type.id}>
                    {type.name}
                  </option>
                ))
              )}
            </select>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <select
              className="form-control"
              value={categoryId}
              onChange={onChangeCategory}
            >
              <option selected="selected">
                Select Category
              </option>
              {props.categories.length > 0 && (
                props.categories.map((type) => (
                  <option value={type.id} key={type.id}>
                    {type.name}
                  </option>
                ))
              )}
            </select>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <select
              className="form-control"
              value={subCategoryId}
              onChange={onChangeSubCategory}
            >
              <option selected="selected">
                Select sub-category
              </option>
              {props.subCategories.length > 0 && (
                props.subCategories.map((type) => (
                  <option value={type.id} key={type.id}>
                    {type.name}
                  </option>
                ))
              )}
            </select>
          </GridItem>
        </GridContainer>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Image</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Description</th>
            <th>Modify</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.products.length !== 0 ? (
            props.products.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{(page - 1) * 10 + i + 1}</th>
                <td>A {item.name}</td>
                <td>
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{ height: '70px' }}
                  />
                </td>
                <td>{item.price} aud</td>
                <td>{item.quantity}</td>
                <td>{item.description}</td>
                <td>
                  <Link
                    style={{ color: '#000' }}
                    to={'/vendor/product-edit/' + item.id + '?page_no=' + page + (categoryId ? `&category=${categoryId}` : '') + (subCategoryId ? `&sub_category=${subCategoryId}` : '')}
                  >
                    <EditIcon
                      onClick={function (event) {
                        toggle();
                      }}
                    />{' '}
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet..</td>
              <td></td>
              <td>No data yet..</td>
              <td></td>
              <td>No data yet..</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Pagination
        count={props.pageCount && Math.ceil(props.pageCount / 10)}
        color="primary"
        page={page}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Product??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a Product</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to="/vendor/add-product">
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
}

const mapStateWithProps = (state) => ({
  products: state.vendor.products,
  complete_products: state.vendor.complete_products,
  pageCount: state.vendor.products_count,
  superCategories: state.vendor.superCategories,
  categories: state.vendor.categories,
  subCategories: state.vendor.subCategories,
  api_loading: state.vendor.api_loading
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllCategoryList: () => dispatch(getAllCategoryList()),
    getAllProducts: (q, superCategoryId, categoryId, subCategoryId, id) => dispatch(getAllProducts(q, superCategoryId, categoryId, subCategoryId, id)),
    getCompleteProducts: (q, superCategoryId, categoryId, subCategoryId, id) => dispatch(getCompleteProducts(q, superCategoryId, categoryId, subCategoryId, id)),
    deleteProduct: (productId) => dispatch(deleteProduct(productId)),
    getCategoryList: (superCategoryId) =>
      dispatch(getCategoryList(superCategoryId, 1, true)),
    getAllSubCategory: (categoryId) => dispatch(getAllSubCategory(categoryId)),
    upload: (data) => dispatch(uploadCsv(data))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(ProductTable);
